export default __webpack_public_path__ + "static/media/5@2x.67b0ec50.png";